import AppBar from '@material-ui/core/AppBar'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import React, { ReactNode, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { APP_BAR_HEIGHT, DEFAULT_LOCATION } from '../Constants'
import { LARGE_LOGO } from '../LogoConstants'
import Typography from '../fhg/components/Typography'
import { getUserData, isPlatformAdmin, isMultipleOrganization } from '../Utils/ServerUtil'
import { FTLink } from './FTLink'
import OrganizationSelect from './eval/components/OrganizationSelect'
import UserMenu from './eval/components/UserMenu'
import ReleaseNotesModal from './eval/components/VersionNotes'
import config from '../config/runtime'
import { apiService } from '../services/api'

interface Props {
    isSignIn?: boolean
    children?: ReactNode
    display?: string
}

const useStyles = makeStyles((theme) => ({
    appBar: {
        flexDirection: 'row',
        height: APP_BAR_HEIGHT,
        alignItems: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        boxShadow: 'none',
        backgroundColor: '#4f2682',
        display: (props: any) => props.display,
        [theme.breakpoints.down('xs')]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
    },
    image: {
        height: 40,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            marginRight: theme.spacing(1),
        },
    },
    signInImage: {
        height: 22,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            marginRight: theme.spacing(1),
        },
    },
    mainContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '100vw',
        width: '100%',
        padding: 0,
    },
    menuItemsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '40px',
        padding: 0,
    },
    profileContainer: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        paddingRight: '24px',
    },
    version: {
        color: theme.palette.secondary.contrastText,
        fontSize: `${theme.size.font['item-title']}rem`,
        opacity: 0.8,
        fontStyle: 'italic',
        textAlign: 'right',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
            opacity: 1,
            textDecoration: 'underline',
        },
    },
}))

/**
 * The App Bar with a logo, navigation links, user menu, and version display.
 */
const MainAppBar: React.FC<Props> = ({ isSignIn, display, children }) => {
    const classes = useStyles({ display })
    const logo = LARGE_LOGO()
    const history = useHistory()
    const isXsDown = useMediaQuery((theme: any) => theme.breakpoints.down('xs'))
    
    const [isReleaseNotesOpen, setReleaseNotesOpen] = useState(false)

    // Get user data and organizations
    const userData = getUserData()
    const { organizations } = userData || {}

    const handleVersionClick = (event: React.MouseEvent) => {
        event.preventDefault()
        event.stopPropagation()
        setReleaseNotesOpen(true)
    }

    const handleCloseReleaseNotes = () => {
        setReleaseNotesOpen(false)
    }

    const handleChangeOrganization = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedOrganizationId = event.target.value as string
        apiService.setOrganization(selectedOrganizationId)
        history.push(DEFAULT_LOCATION)
        window.location.reload()
    }

    return (
        <>
            <AppBar className={classes.appBar} position="static">
                {logo && (
                    <img
                        className={isSignIn ? classes.signInImage : classes.image}
                        src={logo}
                        alt=""
                    />
                )}
                {!isSignIn && !isXsDown && (
                    <Container className={classes.mainContainer}>
                        <Container className={classes.menuItemsContainer}>
                            <FTLink
                                label="evalDashboard.heading"
                                location={DEFAULT_LOCATION}
                            />
                            <FTLink
                                label="nav.support.link"
                                location={'/support'}
                            />
                            {isPlatformAdmin() && (
                                <FTLink
                                    label="nav.admin.link"
                                    location={'/admin'}
                                />
                            )}
                            {(() => {

                                console.log({organizations})


return ""
                            })()}
                            {isMultipleOrganization() && (
                                <OrganizationSelect
                                    onChange={handleChangeOrganization}
                                    userOrganizations={organizations}
                                />
                            )}
                        </Container>
                        <Container className={classes.profileContainer}>
                            <UserMenu />
                            <Typography
                                className={classes.version}
                                onClick={handleVersionClick}
                            >
                                v{config.BUILD_VERSION}
                            </Typography>
                        </Container>
                    </Container>
                )}
                {children}
            </AppBar>
            
            <ReleaseNotesModal
                open={isReleaseNotesOpen}
                onClose={handleCloseReleaseNotes}
            />
        </>
    )
}

export { MainAppBar }
